import { useState } from "react";

// react-router-dom components
import { useNavigate } from "react-router-dom";
import { useEffect } from "react";

// @mui material components
import Card from "@mui/material/Card";

// Material Dashboard 2 PRO React TS components
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";
import MDInput from "components/MDInput";
import MDButton from "components/MDButton";

// Authentication layout components
import BasicLayout from "layouts/authentication/components/BasicLayout";
import axios from "axios";
import Request from "service/request";

function Basic() {
  const [email, setEmail] = useState("");
  const [pwd, setPwd] = useState("");
  const navigate = useNavigate();
  const checkLoginStatus = () => {
    const accessToken = localStorage.getItem("accessToken");
    if (!accessToken) {
      navigate("/login");
    } else {
      navigate("/");
    }
  };

  const handleLogin = async () => {
    try {
      const { data } = await axios.post(`${process.env.REACT_APP_HOST}admin/login`, {
        userId: email,
        password: pwd,
      });

      localStorage.setItem("accessToken", data.data.accessToken);
      localStorage.setItem("allContent", data.data.allContent);
      localStorage.setItem("userId", email);
      navigate("/");
      checkLoginStatus();
    } catch (error: any) {
      console.error("로그인 실패:", error.response.data);
      alert("로그인에 실패했습니다. 다시 시도해주세요.");
      checkLoginStatus();
    }
  };

  const logout = () => {
    localStorage.clear();
    navigate("/login"); // 로그인 페이지로 이동
  };

  useEffect(() => {
    checkLoginStatus();
    logout();
  }, []);
  return (
    <BasicLayout>
      <Card>
        <MDBox
          variant="gradient"
          bgColor="success"
          borderRadius="lg"
          coloredShadow="info"
          mx={2}
          mt={-3}
          p={2}
          mb={1}
          textAlign="center"
        >
          <MDTypography variant="h4" fontWeight="medium" color="white" mt={1}>
            Sign in
          </MDTypography>
        </MDBox>
        <MDBox pt={4} pb={3} px={3}>
          <MDBox
            component="form"
            role="form"
            onSubmit={(e) => {
              e.preventDefault();
              handleLogin();
            }}
          >
            <MDBox mb={2}>
              <MDInput
                type="email"
                label="Email"
                fullWidth
                value={email}
                onChange={(e: any) => {
                  setEmail(e.target.value);
                }}
              />
            </MDBox>
            <MDBox mb={2}>
              <MDInput
                type="password"
                label="Password"
                fullWidth
                value={pwd}
                onChange={(e: any) => {
                  setPwd(e.target.value);
                }}
              />
            </MDBox>
            <MDBox mt={4} mb={1}>
              <MDButton
                variant="gradient"
                color="success"
                fullWidth
                onClick={handleLogin}
                type="submit"
              >
                sign in
              </MDButton>
            </MDBox>
          </MDBox>
        </MDBox>
      </Card>
    </BasicLayout>
  );
}

export default Basic;
